module.exports = __webpack_public_path__ + "img/FotoMo9.8ffaef65.png";